<div class="contact-us-container">
    <div class="contact-info" [class.open]="isOpen">
        <a href="mailto:support@agreem.se" class="contact-item">
            <span class="material-symbols-rounded" aria-hidden="true">mail</span>
            <span>support&#64;agreem.se</span>
        </a>
        <a href="tel:0760050111" class="contact-item">
            <span class="material-symbols-rounded" aria-hidden="true">phone</span>
            <span>076-00 50 111</span>
        </a>
    </div>
    <button
        type="button"
        class="contact-button"
        (click)="toggleContact()"
        [attr.aria-expanded]="isOpen"
        [appTooltip]="'FEATURES.DASHBOARD.CONTACT_INFO_SUPPORT' | translate"
        [tooltipPosition]="'left'"
    >
        <span class="material-symbols-rounded" aria-label="Contact us">headset_mic</span>
    </button>
</div>
